import PlanPay from "../views/plans/plan100Pay";
import Recurrence from "../views/plans/recurrence";

import PlansIcon from "../assets/icons/plans.svg";
import PlansHoverIcon from "../assets/icons/plans-hover.svg";
import RecurrenceIcon from "../assets/icons/recurrence.svg";
import RecurrenceHoverIcon from "../assets/icons/recurrenceHover.svg";

const routesPlans = [
    {
        path: "/plans",
        name: "Planos de venda",
        icon: PlansIcon,
        iconHover: PlansHoverIcon,
        layout: "/plans",
        component: PlanPay,
        redirect: false,
    },

    {
        path: "/recurrence-plan",
        name: "Planos de Recorrência",
        icon: RecurrenceIcon,
        iconHover: RecurrenceHoverIcon,
        layout: "/plans",
        component: Recurrence,
        redirect: false,
    },
]

export default routesPlans;